import { RouteConfig } from 'vue-router';
import { RouteName } from '../routes.constants';
import {
    authenticationGuard,
    AuthRestriction,
    modalGuard,
    featureGuard,
    lightTopNavigation,
} from '../../services';
import { Feature } from '../../util';

const getRewardComponent =
    (component: keyof typeof import('./reward.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "games" */
            './reward.chunk'
        );
        return chunk[component];
    };

export const RewardRoutes: RouteConfig[] = [
    {
        path: '',
        component: getRewardComponent('RewardsPage'),
        meta: {
            ...featureGuard(Feature.REWARDS),
            ...authenticationGuard(AuthRestriction.AUTH_REQUIRED),
            ...lightTopNavigation('rewards.title'),
        },
        children: [
            {
                name: RouteName.REWARDS,
                path: '',
                component: getRewardComponent('RewardsListPage'),
                meta: {
                    ...authenticationGuard(AuthRestriction.AUTH_REQUIRED),
                    corexUserRestriction: 'promotions',
                },
            },
            {
                name: RouteName.PROGRESS_INFO,
                path: 'progress-bar-info',
                component: getRewardComponent('ProgressBarInfoPage'),
                meta: {
                    ...modalGuard(
                        getRewardComponent('ProgressBarInfoPage'),
                        'progress-bar-information.title',
                    ),
                },
            },
            {
                name: RouteName.REWARD,
                path: ':rewardId?/:terms?',
                component: getRewardComponent('RewardPage'),
                meta: {
                    ...authenticationGuard(AuthRestriction.AUTH_REQUIRED),
                    ...modalGuard(
                        getRewardComponent('RewardPage'),
                        'rewards.title',
                    ),
                },
            },
        ],
    },
];
